import React, {useRef, useState} from "react";
import {Backdrop, CircularProgress, Divider, IconButton, InputBase, Paper, styled} from "@mui/material";
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import {handleHttpResponse} from "../utils/http-helpers";
import {useDispatch} from "react-redux";
import {ApiUrl} from "../utils/portal-urls";
import {addLatestBatch, batchOnRefresh} from "../features/allBatchesSlice";
import ShowSnackbar from "../utils/ShowSnackbar";

const StyledPaper = styled(Paper) ({
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: 500,
    marginTop: '10px',
})


export default function NpiPagePasteURLPanel (props) {
    const urlRef = useRef(null);
    const fullOrIncremental = props.fullOrIncremental;
    const [loading, setLoading] = useState(false);
    const [snackbarMsg, setSnackbarMsg] = useState({open: false, msg: '', msgLv: ''})

    const dispatch = useDispatch();

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = urlRef.current;
        const npiUrl = form['url'].value;
        fetchData(npiUrl, fullOrIncremental);
    }

    const incrementalVerification = (url) => {
        console.log(url);
        const pattern = /https:\/\/download\.cms\.gov\/nppes\/NPPES_Data_Dissemination.*[wW]eekly.zip/;
        if (url.length !== 0) {
            return pattern.test(url);
        }
        return false;
    }

    const fullVerification = (url) => {
        console.log(url);
        const pattern = /https:\/\/download\.cms\.gov\/nppes\/NPPES_Data_Dissemination_([jJ]anuary|[fF]ebruary|[mM]arch|[aA]pril|[mM]ay|[jJ]une|[jJ]uly|[aA]ugust|[sS]eptember|[oO]ctober|[nN]ovember|[dD]ecember)_\d{4}.zip/
        if (url.length !== 0) {
            return pattern.test(url);
        }
        return false;
    }


    const fetchData = async (npiUrl, btn) => {
        if (!npiUrl) {
            props.setMsg({error: `Please paste the NPI File link`})
            return;
        }
        let url = "";

        // verify the NPI URL
        if (btn === "Incremental") {
            url = ApiUrl.ExternalSource.importNpiUrl.incremental;
            if (!incrementalVerification(npiUrl)) {
                props.setMsg({error: "Not a valid NPI incremental (weekly) file link, please make sure you are copying the correct incremental (weekly) link from NPI FIle page"});
                return;
            }
        } else if (btn === "Full") {
            url = ApiUrl.ExternalSource.importNpiUrl.full;
            if (!fullVerification(npiUrl)) {
                props.setMsg({error: "Not a valid NPI full (monthly) file link, please make sure you are copying the correct full (monthly) link from NPI FIle page"})
                return;
            }
        }

        const requestOptions = {
            method: 'POST',
            header: { 'Content-Type': 'text/plain'},
            body: `${npiUrl}`
        };
        console.log(`${requestOptions.method} to ${url}, body: ${npiUrl}`);

        try {
            setLoading(true);
            const res = await fetch(url, requestOptions)
            const data = await handleHttpResponse(res);
            dispatch(addLatestBatch({type: 'nppes', 'id': data.id, 'batch': data}));
            dispatch(batchOnRefresh());
        } catch (err) {
            console.error("Import task failed, " + err);
            setSnackbarMsg({ open: true, msg: "Failed to Import New Task", msgLv: 'error'});
        } finally {
            setLoading(false);
        }

        // fetch(url, requestOptions)
        //     .then(handleHttpResponseAcceptAuthError)
        //     .catch((err) => {
        //         console.log("Failed ", err);
        //         if (err) {
        //             props.setMsg({error: `Fail ${err}`});
        //         }
        //     })
        //     .then((res) => {
        //         if (res && res.id) {
        //             props.setBatch(res);
        //             props.setMsg({info: "An import process is running, unable to create new process"});
        //             // dispatch(addNpiBatch(res));
        //             dispatch(addLatestBatch({type: 'nppes', 'id': res.id, 'batch': res}));
        //             dispatch(batchRefresh());
        //         }
        //     })
    }

    return (
        <div style={{marginBottom: '10px'}}>
            <StyledPaper
                component="form"
                elevation={3}
                onSubmit={handleSubmit}
                ref={urlRef}
            >
                <InputBase
                    sx={{ ml: 1, flex: 1}}
                    placeholder="Paste the NPI link"
                    name="url"
                    autoComplete="off"
                />
                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                <IconButton
                    type="submit"
                    sx={{ p: '10px'}}
                    aria-label="search"
                >
                    <KeyboardReturnIcon />
                </IconButton>
            </StyledPaper>
            <ShowSnackbar open={snackbarMsg.open} close={(c) => setSnackbarMsg(c)} msg={snackbarMsg} />
            <Backdrop sx={{zIndex: theme => theme.zIndex.drawer + 1, color: "#fff"}} open={ loading }>
                <CircularProgress color={"inherit"}/>
            </Backdrop>
        </div>

    )
}